import React, { useEffect, useRef } from 'react';
import { oneOf } from 'prop-types';
import styled, { useTheme } from 'styled-components';
import NavLink from 'TMComponents/NavLink';

const Wrapper = styled.div`
    @media (min-width: 426px) {
        max-width: max-content;
    }
`;

const StyledLink = styled(NavLink)`
    ${({ textColor }) => `color: ${textColor};`}
`;

const TrustpilotRating = ({ textColor = 'dark' }) => {
    const theme = useTheme();

    const textColors = {
        light: theme.colorSystem.primary[3],
        dark: theme.colorSystem.primary[1]
    };

    const ref = useRef(null);

    useEffect(() => {
        if (window.Trustpilot) {
            window.Trustpilot.loadFromElement(ref.current, true);
        }
    }, []);

    return (
        <Wrapper>
            <div
                ref={ref}
                className="trustpilot-widget trustpilot-widget-overrides"
                data-locale="en-GB"
                data-template-id="5419b732fbfb950b10de65e5"
                data-businessunit-id={
                    process.env.GATSBY_TRUSTPILOT_BUSINESS_ID
                }
                data-style-height="24px"
                data-style-width="100%"
                data-font-family="Poppins"
                data-text-color={textColors[textColor]}
                data-theme={textColor === 'light' ? 'dark' : 'light'}>
                <StyledLink
                    textColor={textColors[textColor]}
                    href="https://uk.trustpilot.com/review/thinkmoney.co.uk"
                    target="_blank"
                    rel="noopener">
                    Trustpilot
                </StyledLink>
            </div>
        </Wrapper>
    );
};

export default TrustpilotRating;

TrustpilotRating.propTypes = {
    textColor: oneOf(['dark', 'light'])
};
